import { AppBar, Grid, Toolbar } from '@mui/material';

import { MainMenu } from './MainMenu';
import { MemberMenu } from './MemberMenu';

export const Header = () => {


    return (
        <AppBar position="static" sx={{ zIndex: (theme) => theme.zIndex.drawer - 10, height: 56, borderBottom: 6, borderColor: 'red' }} >
            <Toolbar sx={{ p: 0 }}>
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <MainMenu />
                    </Grid>
                    <Grid item>
                        <MemberMenu />
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    )
}
